import { useState, useEffect } from 'react';
import { NavBar }         from './components/layout/NavBar';
import { Footer }         from './components/layout/Footer';
import { Hero }           from './components/sections/Hero/Hero';
import { Skills }         from './components/sections/Skills/Skills';
import { Projects }       from './components/sections/Projects/Projects';
import { ECertificates }  from './components/sections/ECertificates/ECertificates';
import { Contact }        from './components/sections/Contact/Contact';
import { HireMeButton }   from './components/ui/HireMeButton';
import { ThemeProvider }  from './context/ThemeContext';

// Global styles — loaded once here, not per-component
import './styles/tokens.css';
import './styles/global.css';

/**
 * App — root component.
 * Manages the Hire Me modal open/close state so it can be
 * triggered from both the Hero CTAs and the floating FAB.
 */
function AppContent() {
  const [isContactOpen, setIsContactOpen] = useState(false);

  // Track mouse position for the CSS glow effect on desktop
  useEffect(() => {
    const onMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth) * 100;
      const y = (e.clientY / window.innerHeight) * 100;
      document.documentElement.style.setProperty('--mouse-x', `${x}%`);
      document.documentElement.style.setProperty('--mouse-y', `${y}%`);
    };
    window.addEventListener('mousemove', onMouseMove, { passive: true });
    return () => window.removeEventListener('mousemove', onMouseMove);
  }, []);

  const openContact  = () => setIsContactOpen(true);
  const closeContact = () => setIsContactOpen(false);

  return (
    <>
      <NavBar />

      <main id="main-content">
        <Hero onHireMeClick={openContact} />
        <Skills />
        <Projects />
        <ECertificates />
      </main>

      <Footer />

      {/* Floating Hire Me button — visible always */}
      <HireMeButton onClick={openContact} />

      {/* Contact modal — portal-free, controlled by App state */}
      <Contact isOpen={isContactOpen} onClose={closeContact} />
    </>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}
